import { create } from "zustand"
import { persist } from "zustand/middleware"
import { getMyPermissions } from "../services/axiosServices"
import { STORAGE_KEYS } from "../Helper/localStorageHandler"

let activePermissionsPromise = null

export const userStore = create(
  persist(
    (set, get) => ({
      keycloakUserId: null,
      userId: null,
      userEmail: null,
      name: null,
      tenantId: null,
      orgId: null,
      orgName: null,
      orgCreated: null,
      workspaceUrl: null,
      role: null,
      permissions: [],
      siteIds: [],
      permissionsLoaded: false,
      permissionsFetchedOrgId: null,

      setUserData: (data) =>
        set((state) => ({
          ...state,
          ...data,
        })),

      fetchUserPermissions: async (force = false) => {
        const { orgId, permissionsLoaded, permissionsFetchedOrgId } = get()
        if (!force && permissionsLoaded && orgId === permissionsFetchedOrgId) {
          return
        }

        if (!force && activePermissionsPromise) {
          return activePermissionsPromise
        }

        activePermissionsPromise = (async () => {
          try {
            const res = await getMyPermissions()
            const {
              permissions = [],
              role = null,
              siteIds = [],
            } = res?.data?.data || {}
            const currentOrgId = get().orgId
            set({
              permissions,
              role,
              siteIds,
              permissionsLoaded: true,
              permissionsFetchedOrgId: currentOrgId,
            })
            return res
          } catch (err) {
            console.error("Failed to fetch user permissions:", err)
            set({ permissionsLoaded: true })
            throw err
          } finally {
            activePermissionsPromise = null
          }
        })()

        return activePermissionsPromise
      },

      setOrgId: (orgId) => set({ orgId }),
      setOrgName: (orgName) => set({ orgName }),
      setOrgCreated: (orgCreated) => set({ orgCreated }),
      setWorkspaceUrl: (workspaceUrl) => set({ workspaceUrl }),
      clearUserData: () =>
        set({
          keycloakUserId: null,
          userId: null,
          userEmail: null,
          name: null,
          tenantId: null,
          orgId: null,
          orgName: null,
          orgCreated: null,
          workspaceUrl: null,
          role: null,
          permissions: [],
          siteIds: [],
          permissionsLoaded: false,
          permissionsFetchedOrgId: null,
        }),
    }),
    {
      name: STORAGE_KEYS.USER_DATA,
      partialize: (state) => ({
        role: state.role,
      }),
    },
  ),
)
